import PropTypes from 'prop-types';
import React from 'react';

import { CartPreview } from '@components/cart-preview';
import { Modal } from '@components/modal/new';

const CartPreviewModal = ({ visibleCart, setVisibleCart, setShouldShowOrderSettingsModal }) => {
  return (
    <Modal
      header={null}
      hasInnerScroll
      footer={null}
      variant="side"
      open={visibleCart}
      onClose={() => setVisibleCart(false)}
      mx="0"
      // The points-redemption editor portals to document.body (for a full-screen backdrop), which sits
      // outside this modal's DOM subtree. With MUI's focus trap (enforceFocus) on, focusing the points
      // input would be immediately stolen back into the cart — so relax enforceFocus to let it be typed in.
      disableEnforceFocus
    >
      <CartPreview
        hidePreview={() => setVisibleCart(false)}
        onSettingsClick={() => setShouldShowOrderSettingsModal(true)}
      />
    </Modal>
  );
};

CartPreviewModal.propTypes = {
  visibleCart: PropTypes.bool.isRequired,
  setVisibleCart: PropTypes.func.isRequired,
  setShouldShowOrderSettingsModal: PropTypes.func.isRequired,
};

export { CartPreviewModal };
